import axios from 'axios';
import * as types from './actionTypes';
import * as urls from './urlTypes';
import { getCurrentTimeInHHMMSS, dictionaryDetailExp, updatedPayload } from '../util/CrosstabUtils';
import { checkSPCForVersion } from '../util/autocodeUtils';

// Thunks - actions that return a function that accepts a dispatch
export const removeCrosstabData = crosstabKey => ({
  type: types.REMOVE_CROSSTAB_DATA,
  crosstabKey,
});

export const updateCrosstabTitleHeader = crosstabKey => ({
  type: types.UPDATE_CROSSTAB_TITLE_HEADER,
  payload: crosstabKey,
});

export const addDDNHCSData = crosstabKey => ({
  type: types.ADD_DD_NHCS_CROSSTAB_REPORT,
  payload: crosstabKey,
});

export const clearSampleWeighted = targetGrid => ({
  type: types.CLEAR_CROSSTAB_SAMPLE_WEIGHTED,
  targetGrid,
});

export const updateSampleWeighted = (gridData, targetGrid) => ({
  type: types.UPDATE_CROSSTAB_SAMPLE_WEIGHTED,
  gridData,
  targetGrid,
});

export const clearSampleWeightedKPIs = () => ({
  type: types.CLEAR_SAMPLE_WEIGHTED_CROSSTAB_KPI,
});

export const exportBaseSelectionList = (
  itemsLeft,
  itemsRight,
  universalStudy
) => ({
  type: types.EXPORT_BASE_SELCTION_LIST,
  payload: {
    itemsLeft,
    itemsRight,
    universalStudy,
  },
});

export const selectCrosstabGrid = idKey => ({
  type: types.SELECT_CROSSTAB_GRID,
  idKey,
});

export const deleteCrosstabGrid = () => ({
  type: types.DELETE_CROSSTAB_GRID,
  // idKey, #Commnted for beta release
  // isActive,
});

export function fetchStandardBaseList({ token, uid, accountId, productNo }) {
  const url = `${urls.ROOT_URL}/crosstab/standard-base/${uid}/${accountId}/${productNo}`;
  return dispatch => {
    axios({
      url,
      method: 'get',
      headers: {
        Accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',

      validateStatus: status => status >= 200 && status < 501,
    })
      .then(response =>
        dispatch({
          type: types.FETCH_STANDARD_BASE_LIST,
          payload: response.data.data,
        })
      )
      .catch(response => console.warn(response));
  };
}

export const updateCrosstabGrid = (idKey, updatedData) => ({
  type: types.UPDATE_CROSSTAB_GRID,
  idKey,
  updatedData,
});

export const importSPC = payload => ({
  type: types.LOAD_SAVED_CROSSTAB,
  payload,
  importSPC: true,
});

export const removeCrossTabKpiInfo = () => ({
  type: types.REMOVE_CROSSTAB_KPI,
});

export const setSelectedBase = (
  selectedBase,
  selectedBaseNode,
  selectedBaseGroup
) => ({
  type: types.SET_SELECTED_BASE,
  selectedBase,
  selectedBaseNode,
  selectedBaseGroup,
});

export const setActiveCrosstabTable = activeCrosstabTable => ({
  type: types.SET_ACTIVE_CROSSTAB_TABLE,
  activeCrosstabTable,
});

export function exportCrosstab({
  token,
  uid,
  accountId,
  crosstabRequest,
  crosstabDisplay,
}) {
  const url = `${urls.ROOT_URL}/reports/export/crosstab/${uid}/${accountId}`;
  return dispatch => {
    axios({
      url,
      method: 'post',
      headers: {
        Accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
      data: {
        crosstabRequest,
        crosstabDisplay,
      },
      validateStatus: status => status >= 200 && status < 501,
    })
      .then(response =>
        dispatch({
          type: types.EXPORT_CROSSTAB,
          payload: response.data.data,
        })
      )
      .catch(response => console.warn(response));
  };
}

export function deleteSavedCrosstabs(token, uid, accountId, id) {
  const url = `${urls.ROOT_URL}/crosstab/${uid}/${accountId}/${id}`;
  return dispatch => {
    axios({
      url,
      method: 'delete',
      headers: {
        Accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
      data: {},
      validateStatus: status => status >= 200 && status < 202,
    })
      .then(() =>
        dispatch({
          type: types.DELETE_SAVED_CROSSTAB,
          payload: id,
        })
      )
      .catch(response => console.warn(response));
  };
}

// Required Parameters: targetGrid, token, uid, accountId, productNo,
// weightType, divisor, expressionList, selectedNames
// Optional Paramaters: sourceGrid, gridData, titlePrefix, originalNames
// TODO: Refactor required
export function fetchTrendsKPI({
  token,
  uid,
  accountId,
  productNo,
  weightType,
  divisor,
  expressionList,
  headerList,
}) {
  const url = `${urls.ROOT_URL}/crosstab/samplewgtd`;
  return dispatch => {
    axios({
      url,
      method: 'post',
      headers: {
        Accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
      validateStatus: status => status >= 200 && status < 202,
      data: {
        uid,
        accountId,
        productNo,
        weightType,
        divisor,
        expressionList,
      },
    })
      .then(response => {
        dispatch({
          type: types.FETCH_CROSSTAB_TRENDS_KPI,
          payload: {
            expressionList,
            productNo,
            response: response.data.data,
            headerList,
          },
        });
      })
      .catch(response => console.warn(response));
  };
}

// Required Parameters: targetGrid, token, uid, accountId, productNo,
// weightType, divisor, expressionList, selectedNames
// Optional Paramaters: sourceGrid, gridData, titlePrefix, originalNames
// TODO: Refactor required

export const fetchKPIThunk = payload => ({
  type: types.FETCH_CROSSTAB_KPI,
  payload,
});

export const fetchKPIApi = (url, requestData, kpiExpression, dispatch) => {
  axios({
    url,
    method: 'post',
    headers: {
      Accept: 'application/json;charset=UTF-8',
    },
    withCredentials: true,
    responseType: 'json',
    validateStatus: status => status >= 200 && status < 202,
    data: requestData,
  })
    .then(response => {
      const payload = {
        ...response.data.data,
        expressionList: requestData.expressionList,
        productNo: requestData.productNo,
        response: response.data.data,
        kpiExpression,
      };
      dispatch(fetchKPIThunk(payload));
    })
    .catch(response => console.warn(response));
};

export const fetchKPI = ({
  token,
  uid,
  accountId,
  productNo,
  weightType,
  divisor,
  expressionList,
  kpiExpression,
}) => dispatch => {
  const url = `${urls.ROOT_URL}/crosstab/samplewgtd`;
  const requestData = {
    uid,
    accountId,
    productNo,
    weightType,
    divisor,
    expressionList,
  };
  fetchKPIApi(url, requestData, kpiExpression, dispatch);
};

// Required Parameters: accountId, productNo, expressionList, selectedNames
// TODO: Refactor required
export const fetchKPISample = ({
  accountId,
  productNo,
  expressionList,
  response,
}) => ({
  type: types.FETCH_SAMPLE_CROSSTAB_KPI,
  payload: { ...response, expressionList, productNo, accountId },
});

// Required Parameters: targetGrid, token, uid, accountId,
// productNo, weightType, divisor, expressionList, selectedNames
// Optional Paramaters: sourceGrid, gridData, titlePrefix, originalNames
export function getSampleWeighted({
  sourceGrid,
  targetGrid,
  token,
  uid,
  accountId,
  productNo,
  weightType,
  divisor,
  expressionList,
  selectedNames,
  gridData,
  recTypes,
  titlePrefix,
  originalNames,
  objSmartSearchArray,
  isLabelUpdated,
  oldProductNo,
  userDefinedText,
  weightChange,
}) {
  userDefinedText = userDefinedText || false;
  const url = `${urls.ROOT_URL}/crosstab/samplewgtd`;
  return dispatch => {
    axios({
      url,
      method: 'post',
      headers: {
        Accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
      validateStatus: status => status >= 200 && status < 202,
      data: {
        uid,
        accountId,
        productNo,
        weightType,
        divisor,
        expressionList,
      },
    })
      .then(response => {
        dispatch({
          type: types.GET_CROSSTAB_SAMPLE_WEIGHTED,
          payload: response.data.data,
          gridData,
          sourceGrid,
          targetGrid,
          selectedNames,
          expressionList,
          recTypes,
          titlePrefix,
          originalNames,
          objSmartSearchArray,
          isLabelUpdated,
          productNo,
          oldProductNo,
          userDefinedText,
          weightChange,
          uid,
          accountId,
        });
      })
      .catch(response => console.warn(response));
  };
}

// Required Parameters: accountId, productNo, expressionList, selectedNames
// TODO: Refactor required
export const getSampleWeightedData = ({
  sourceGrid,
  targetGrid,
  accountId,
  productNo,
  expressionList,
  selectedNames,
  gridData,
  recTypes,
  titlePrefix,
  originalNames,
  objSmartSearchArray,
  response,
  isLabelUpdated,
}) => ({
  type: types.GET_CROSSTAB_SAMPLE_WEIGHTED_DATA,
  payload: response,
  gridData,
  sourceGrid,
  targetGrid,
  selectedNames,
  expressionList,
  recTypes,
  titlePrefix,
  originalNames,
  objSmartSearchArray,
  productNo,
  accountId,
  isLabelUpdated,
});

export function runCrosstab({
  token,
  uid,
  accountId,
  products,
  studyDescriptions,
  weightType,
  divisor,
  colExpressionList,
  colHeaderList,
  rowExpressionList,
  rowHeaderList,
  baseList,
  baseHeaderList,
  crosstabTitle,
  colOriginalHeaderList,
  rowOriginalHeaderList,
  baseOriginalHeaderList,
  baseIDList,
  studyInfo,
  runType,
  highlightAndFilter,
  conditionalFormatting,
  selectedBaseNode,
  selectedBaseGroup,
  selectedBaseID,
  userDefinedBaseList,
  standardBaseList,
  crosstabColumns,
  crosstabRows,
  selectedStandardBaseFlag,
  crosstabRequestData,
  selectedWeight,
}) {
  const url = `${urls.ROOT_URL}/crosstab/${uid}/${accountId}`;
  const newColHeaderList = colHeaderList
    ? colHeaderList.map(item => item.replace(String.fromCharCode(10020), ''))
    : [];
  const newRowHeaderList = rowHeaderList
    ? rowHeaderList.map(item => item.replace(String.fromCharCode(10020), ''))
    : [];
  const newBaseHeaderList = baseHeaderList
    ? baseHeaderList.map(item => item.replace(String.fromCharCode(10020), ''))
    : [];

  const newColOriginalHeaderList = colOriginalHeaderList
    ? colOriginalHeaderList.map(item =>
        item.replace(String.fromCharCode(10020), '')
      )
    : [];
  const newRowOriginalHeaderList = rowOriginalHeaderList
    ? rowOriginalHeaderList.map(item =>
        item.replace(String.fromCharCode(10020), '')
      )
    : [];
  const newBaseOriginalHeaderList = baseOriginalHeaderList
    ? baseOriginalHeaderList.map(item =>
        item.replace(String.fromCharCode(10020), '')
      )
    : [];
  let requestData;
  if (selectedStandardBaseFlag) {
    requestData = { ...crosstabRequestData };
    requestData.products = products;
    requestData.weightType = weightType;
    requestData.divisor = divisor;
    requestData.baseList = baseList;
    requestData.baseHeaderList = baseHeaderList;
  } else {
    requestData = {
      products,
      weightType,
      divisor,
      baseList,
      baseHeaderList,
      colExpressionList,
      colHeaderList: newColHeaderList,
      rowExpressionList,
      rowHeaderList: newRowHeaderList,
    };
  }
  return dispatch => {
    axios({
      url,
      method: 'post',
      withCredentials: true,
      responseType: 'json',
      headers: {
        Accept: 'application/json;charset=UTF-8',
      },
      validateStatus: status => status >= 200 && status < 202,
      data: { ...requestData },
    })
      .then(response =>
        dispatch({
          type: types.SHOW_CROSSTAB_GRID,
          payload:
            products.length > 1 ? response.data.data : [response.data.data],
          studyDescriptions,
          crosstabTitle,
          colOriginalHeaderList: newColOriginalHeaderList,
          rowOriginalHeaderList: newRowOriginalHeaderList,
          baseOriginalHeaderList: newBaseOriginalHeaderList,
          colExpressionList,
          rowExpressionList,
          colHeaderList: newColHeaderList,
          rowHeaderList: newRowHeaderList,
          baseList,
          baseHeaderList: newBaseHeaderList,
          studyInfo,
          baseIDList,
          runType,
          highlightAndFilter,
          conditionalFormatting,
          selectedBaseNode,
          selectedBaseGroup,
          selectedBaseID,
          userDefinedBaseList,
          standardBaseList,
          accountId,
          crosstabColumns,
          crosstabRows,
          selectedStandardBaseFlag,
          requestData,
          selectedWeight,
        })
      )
      .catch(response => console.warn(response));
  };
}
export const resetLoadedCrossTabInfo = () => dispatch => {
  dispatch({
    type: types.UPDATE_SAVED_CROSSTAB_INFO,
    resetTable: true,
    updateLoadedCrosstab: true,
    title: '',
    tableTitle: '',
  });
};

export const saveCrosstabTableTitle = data => dispatch => {
  dispatch({
    type: types.UPDATE_SAVED_CROSSTAB_INFO,
    payload: { newId: data.id },
    title: data.title,
    tableTitle: data.title,
    updateLoadedCrosstab: data.isDuplicateCrossTabTitle,
  });
};

export function saveCrosstab(
  {
    token,
    uid,
    accountId,
    products,
    weightType,
    divisor,
    colExpressionList,
    colHeaderList,
    baseList,
    baseHeaderList,
    rowExpressionList,
    rowHeaderList,
    title,
    crosstabId,
    idKey,
    callbackSpinnerControl,
    isReplace,
    attributes,
  },
  callBackFn
) {
  callbackSpinnerControl(true);
  const urlSave = `${urls.ROOT_URL}/crosstab/${uid}/${accountId}`;
  const urlReplace = `${urls.ROOT_URL}/crosstab/${uid}/${accountId}/${crosstabId}`;
  const url = crosstabId ? urlReplace : urlSave;

  const newColHeaderList = colHeaderList
    ? colHeaderList.map(item => item.replace(String.fromCharCode(10020), ''))
    : [];
  const newRowHeaderList = rowHeaderList
    ? rowHeaderList.map(item => item.replace(String.fromCharCode(10020), ''))
    : [];
  const newBaseHeaderList = baseHeaderList
    ? baseHeaderList.map(item => item.replace(String.fromCharCode(10020), ''))
    : [];

  return dispatch => {
    axios({
      url,
      method: 'put',
      headers: {
        Accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
      validateStatus: status => status >= 200 && status < 202,
      data: {
        products,
        weightType,
        divisor,
        baseList,
        baseHeaderList: newBaseHeaderList,
        colExpressionList,
        colHeaderList: newColHeaderList,
        rowExpressionList,
        rowHeaderList: newRowHeaderList,
        title,
        attributes,
      },
    })
      .then(response => {
        callbackSpinnerControl(false);
        if (response.status === 200) {
          callBackFn(false);
          return dispatch({
            type: types.UPDATE_SAVED_CROSSTAB_INFO,
            payload: response.data.data,
            idKey,
            crosstabId,
            title,
            tableTitle: title,
            updateLoadedCrosstab: false,
            resetTable: false,
          });
        }
        if (response.status === 400) {
          if (response.data.message) {
            if (response.data.message.includes('Duplicate Crosstab Title')) {
              callBackFn(true);
            }
          }
        }
      })
      .catch(response => {
        // console.warn(response);
        const re = response.response;
        if (re && re.status === 400 && re.data.message) {
          const msg = response.response.data.message;
          const newId = msg.substring(msg.lastIndexOf(':') + 2, msg.length);
          const isDuplicate = response.response.data.message.includes(
            'Duplicate Crosstab Title'
          );

          if (isDuplicate && !isReplace && !crosstabId) {
            callBackFn(true);
            return dispatch({
              type: types.UPDATE_CROSSTAB_ID,
              payload: { newId: parseInt(newId, 10) },
              idKey,
            });
          }
          if (isDuplicate && isReplace) {
            callBackFn(false);
          }
          if (isDuplicate && isReplace) {
            return dispatch({
              type: types.UPDATE_SAVED_CROSSTAB_INFO,
              payload: { newId: parseInt(newId, 10) },
              idKey,
              crosstabId,
              title,
              tableTitle: title,
              updateLoadedCrosstab: true,
              resetTable: false,
            });
          }
        }
      });
  };
}

export function showSavedCrosstabs(token, uid, accountId) {
  const url = `${urls.ROOT_URL}/crosstab/${uid}/${accountId}/list`;
  return dispatch => {
    axios({
      url,
      method: 'get',
      headers: {
        Accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
      validateStatus: status => status >= 200 && status < 202,
    })
      .then(response =>
        dispatch({
          type: types.SHOW_SAVED_CROSSTABS,
          payload: response.data.data,
        })
      )
      .catch(response => console.warn(response));
  };
}

export function loadSavedCrosstab(token, uid, accountId, id) {
  const url = `${urls.ROOT_URL}/crosstab/${uid}/${accountId}/${id}`;
  return dispatch => {
    axios({
      url,
      method: 'get',
      headers: {
        Accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
      validateStatus: status => status >= 200 && status < 202,
    })
      .then(response => {
        if (checkSPCForVersion(response.data.data, true)) {
          dispatch({
            type: types.UPDATE_NEWSPC_SAVED_CROSSTAB_DATA,
            payload: { id, ...response.data.data },
          });
        } else {
          dispatch({
            type: types.LOAD_SAVED_CROSSTAB,
            payload: { id, ...response.data.data },
          });
        }
      })
      .catch(response => console.warn(response));
  };
}

export function validateCRB({
  token,
  uid,
  accountId,
  productNo,
  weightType,
  divisor,
  baseList,
  baseHeaderList,
  baseOriginalHeaderList,
  colExpressionList,
  colHeaderList,
  colOriginalHeaderList,
  rowExpressionList,
  rowHeaderList,
  rowOriginalHeaderList,
  oldProductNo,
  isColLabelUpdated,
  isRowLabelUpdated,
}) {
  const url = `${urls.ROOT_URL}/crosstab/${uid}/${accountId}/validate`;

  const newColHeaderList = colHeaderList
    ? colHeaderList.map(item => item.replace(String.fromCharCode(10020), ''))
    : [];
  const newRowHeaderList = rowHeaderList
    ? rowHeaderList.map(item => item.replace(String.fromCharCode(10020), ''))
    : [];
  const newBaseHeaderList = baseHeaderList
    ? baseHeaderList.map(item => item.replace(String.fromCharCode(10020), ''))
    : [];

  const newColOriginalHeaderList = colOriginalHeaderList
    ? colOriginalHeaderList.map(item =>
        item.replace(String.fromCharCode(10020), '')
      )
    : [];
  const newRowOriginalHeaderList = rowOriginalHeaderList
    ? rowOriginalHeaderList.map(item =>
        item.replace(String.fromCharCode(10020), '')
      )
    : [];
  const newBaseOriginalHeaderList = baseOriginalHeaderList
    ? baseOriginalHeaderList.map(item =>
        item.replace(String.fromCharCode(10020), '')
      )
    : [];

  return dispatch =>
    new Promise((resolve, reject) => {
      axios({
        url,
        method: 'post',
        headers: {
          Accept: 'application/json;charset=UTF-8',
        },
        withCredentials: true,
        responseType: 'json',
        data: {
          products: [`${productNo}`],
          weightType,
          divisor,
          title: 'Title Not Needed',
          baseList,
          oldProductNo,
          baseHeaderList: newBaseHeaderList,
          colExpressionList,
          colHeaderList: newColHeaderList,
          rowExpressionList,
          rowHeaderList: newRowHeaderList,
        },
      })
        .then(response => {
          dispatch({
            type: types.SHOW_VALIDATE_RESPONSE,
            payload: response.data.data,
            baseOriginalHeaderList: newBaseOriginalHeaderList,
            colOriginalHeaderList: newColOriginalHeaderList,
            rowOriginalHeaderList: newRowOriginalHeaderList,
            oldProductNo,
            isColLabelUpdated,
            isRowLabelUpdated,
          });
          resolve();
        })
        .catch(response => {
          console.warn(response);
          reject();
        });
    });
}

export function validateCRBForMultipleProducts({
  token,
  uid,
  accountId,
  productNo,
  weightType,
  divisor,
  baseList,
  baseHeaderList,
  baseOriginalHeaderList,
  colExpressionList,
  colHeaderList,
  colOriginalHeaderList,
  rowExpressionList,
  rowHeaderList,
  rowOriginalHeaderList,
  isColLabelUpdated,
  isRowLabelUpdated,
}) {
  const url = `${urls.ROOT_URL}/crosstab/${uid}/${accountId}/trend/validate`;

  const newColHeaderList = colHeaderList
    ? colHeaderList.map(item => item.replace(String.fromCharCode(10020), ''))
    : [];
  const newRowHeaderList = rowHeaderList
    ? rowHeaderList.map(item => item.replace(String.fromCharCode(10020), ''))
    : [];
  const newBaseHeaderList = baseHeaderList
    ? baseHeaderList.map(item => item.replace(String.fromCharCode(10020), ''))
    : [];

  const newColOriginalHeaderList = colOriginalHeaderList
    ? colOriginalHeaderList.map(item =>
        item.replace(String.fromCharCode(10020), '')
      )
    : [];
  const newRowOriginalHeaderList = rowOriginalHeaderList
    ? rowOriginalHeaderList.map(item =>
        item.replace(String.fromCharCode(10020), '')
      )
    : [];
  const newBaseOriginalHeaderList = baseOriginalHeaderList
    ? baseOriginalHeaderList.map(item =>
        item.replace(String.fromCharCode(10020), '')
      )
    : [];

  return dispatch =>
    axios({
      url,
      method: 'post',
      headers: {
        Accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
      data: {
        products: productNo,
        weightType,
        divisor,
        baseList,
        baseHeaderList: newBaseHeaderList,
        colExpressionList,
        colHeaderList: newColHeaderList,
        rowExpressionList,
        rowHeaderList: newRowHeaderList,
      },
    })
      .then(response =>
        dispatch({
          type: types.SHOW_VALIDATE_RESPONSE,
          payload: response.data.data,
          baseOriginalHeaderList: newBaseOriginalHeaderList,
          colOriginalHeaderList: newColOriginalHeaderList,
          rowOriginalHeaderList: newRowOriginalHeaderList,
          trendMultipleProducts: true,
          isColLabelUpdated,
          isRowLabelUpdated,
        })
      )
      .catch(response => console.warn(response));
}

export const updateCrosstabTitleList = (deletedIndex, targetGrid) => ({
  type: types.UPDATE_CROSSTAB_TITLE_LIST,
  deletedIndex,
  targetGrid,
});

export const toggleCrosstabGridData = (
  targetGrid,
  updatedCrosstabTableList,
  updatedGridData,
  updatedCrosstabRequestData,
  updatedCrosstabPayload
) => ({
  type: types.TOGGLE_CROSSTAB_GRID_DATA,
  targetGrid,
  updatedCrosstabTableList,
  updatedGridData,
  updatedCrosstabRequestData,
  updatedCrosstabPayload,
});

export const updateRenamedGridIndex = (deletedObj, targetGrid) => ({
  /** deleteObj can be { oldIndex: newIndex }  */
  type: types.UPDATE_RENAMED_GRID_INDEX,
  deletedObj,
  targetGrid,
});

export const updateToggleLabelFlag = gridType => ({
  type: types.UPDATE_TOGGLE_LABEL_FLAG,
  gridType,
});

export const updateCrosstabSort = (direction, variable, index) => ({
  type: types.UPDATE_COLUMN_CT_SORT,
  direction,
  variable,
  index,
});

export const updateCrosstabGridTitleHeader = crosstabKey => ({
  type: types.UPDATE_CROSSTAB_GRID_TITLE_HEADER,
  payload: crosstabKey,
});

export function getBreadCrumbs({
  uid,
  accountId,
  productNo,
  expressionList,
  gridType,
}) {
  const url = `${urls.ROOT_URL}/dictionary/label/${uid}/${accountId}/${productNo}`;
  return dispatch =>
    axios({
      url,
      method: 'post',
      headers: {
        Accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
      data: expressionList,
    })
      .then(response =>
        dispatch({
          type: types.EXPRESSIONS_BREADCRUMBS_LIST,
          payload: response.data.data,
          requestList: expressionList,
          gridType,
        })
      )
      .catch(response => console.warn(response));
}

export const getDictionaryDataDetails = ({
  uid,
  accountId,
  productNo,
  expressionList,
  gridType,
}) => {
  const updatedExpList = dictionaryDetailExp(expressionList);
  const url = `${urls.ROOT_URL}/dictionary/detail/${uid}/${accountId}/${productNo}`;
  return dispatch =>
    axios({
      url,
      method: 'post',
      headers: {
        Accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
      data: updatedExpList,
    })
      .then(response =>
        dispatch({
          type: types.EXPRESSIONS_DETAILS_LIST,
          payload: updatedPayload(response.data.data, updatedExpList),
          requestList: expressionList,
          gridType,
        })
      )
      .catch(response => console.warn(response));
};

export const restoreGridTitle = (index, gridType) => ({
  type: types.RESTORE_TITLE_NAME,
  index,
  gridType,
});

export const getFunctionsForProbabilities = () => ({
  type: types.GET_FUNCTION_LIST_FOR_PROBABILITIES,
});

const encodeObjToQueryParam = obj => {
  const sq = _.cloneDeep(obj);
  Object.keys(sq).map(k => {
    if (!sq[k] || _.isEmpty(sq[k])) {
      delete sq[k];
    }
    return false;
  });
  return Object.entries(sq)
    .map(e => e.join('='))
    .join('&');
};


export function getSharedCrossTabList(userId) {
  const url = `${urls.API_GATEWAY_URL}/api/user-service/user/${userId}/spcx`;
  return dispatch => {
    axios({
      url,
      method: 'get',
      withCredentials: true,
      responseType: 'json',

      validateStatus: status => status >= 200 && status < 501,
    })
      .then(response =>
        dispatch({
          type: types.OPEN_SHARED_CROSSTAB,
          payload: response.data,
        })
      )
      .catch(response => console.warn(response));
  };
}

export function shareCrosstab(userId, spcxId) {
  const url = `${urls.API_GATEWAY_URL}/api/user-service/user/spcx/`;
  // return dispatch => {
  return axios({
    url,
    method: 'post',
    headers: {
      Accept: 'application/json;charset=UTF-8',
    },
    withCredentials: true,
    responseType: 'json',
    data: {
      userId,
      spcxId,
    },
    validateStatus: status => status >= 200 && status < 501,
  })
    .then(response => {
      if (response.status === 200) {
        return response;
      }
      return response;
    })
    .catch(response => console.warn(response));
  // };
}

export const loadSharedCrosstab = (id, data) => dispatch => {
  dispatch({
    type: types.LOAD_SAVED_CROSSTAB,
    payload: data,
  });
};

export const setLabelTypeAC = labelConfig => ({
  type: types.SET_SELECTED_LABEL_AC,
  labelConfig,
});

export const setDictionaryUseQuestions = useQuestions => ({
  type: types.SET_DICTIONARY_USE_QUESTIONS,
  payload: useQuestions,
});

export function getAutocodeSampleWeighted({
  sourceGrid,
  targetGrid,
  token,
  uid,
  accountId,
  productNo,
  weightType,
  divisor,
  expressionList,
  selectedNames,
  gridData,
  recTypes,
  titlePrefix,
  originalNames,
  objSmartSearchArray,
  isLabelUpdated,
  oldProductNo,
  userDefinedText,
  weightChange,
}) {
  userDefinedText = userDefinedText || false;
  const url = `${urls.ROOT_URL}/crosstab/samplewgtd`;
  return dispatch => {
    axios({
      url,
      method: 'post',
      headers: {
        Accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
      validateStatus: status => status >= 200 && status < 202,
      data: {
        uid,
        accountId,
        productNo,
        weightType,
        divisor,
        expressionList,
      },
    })
      .then(response => {
        dispatch({
          type: types.GET_AUTOCODE_SAMPLE_WEIGHTED,
          payload: response.data.data,
          gridData,
          sourceGrid,
          targetGrid,
          selectedNames,
          expressionList,
          recTypes,
          titlePrefix,
          originalNames,
          objSmartSearchArray,
          isLabelUpdated,
          productNo,
          oldProductNo,
          userDefinedText,
          weightChange,
          uid,
          accountId,
        });
      })
      .catch(response => console.warn(response));
  };
}

export function saveNewSPCCrosstab(
  {
    uid,
    accountId,
    title,
    crosstabId,
    idKey,
    callbackSpinnerControl,
    isReplace,
    spcObject,
  },
  callBackFn
) {
  callbackSpinnerControl(true);
  const urlSave = `${urls.ROOT_URL}/crosstab/${uid}/${accountId}`;
  const urlReplace = `${urls.ROOT_URL}/crosstab/${uid}/${accountId}/${crosstabId}`;
  const url = crosstabId ? urlReplace : urlSave;

  return dispatch => {
    axios({
      url,
      method: 'put',
      headers: {
        Accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
      validateStatus: status => status >= 200 && status < 202,
      data: spcObject,
    })
      .then(response => {
        callbackSpinnerControl(false);
        if (response.status === 200) {
          callBackFn(false);
          return dispatch({
            type: types.UPDATE_SAVED_CROSSTAB_INFO,
            payload: response.data.data,
            idKey,
            crosstabId,
            title,
            tableTitle: title,
            updateLoadedCrosstab: false,
            resetTable: false,
          });
        }
        if (response.status === 400) {
          if (response.data.message) {
            if (response.data.message.includes('Duplicate Crosstab Title')) {
              callBackFn(true);
            }
          }
        }
      })
      .catch(response => {
        // console.warn(response);
        const re = response.response;
        if (re && re.status === 400 && re.data.message) {
          const msg = response.response.data.message;
          const newId = msg.substring(msg.lastIndexOf(':') + 2, msg.length);
          const isDuplicate = response.response.data.message.includes(
            'Duplicate Crosstab Title'
          );

          if (isDuplicate && !isReplace && !crosstabId) {
            callBackFn(true);
            return dispatch({
              type: types.UPDATE_CROSSTAB_ID,
              payload: { newId: parseInt(newId, 10) },
              idKey,
            });
          }
          if (isDuplicate && isReplace) {
            callBackFn(false);
          }
          if (isDuplicate && isReplace) {
            return dispatch({
              type: types.UPDATE_SAVED_CROSSTAB_INFO,
              payload: { newId: parseInt(newId, 10) },
              idKey,
              crosstabId,
              title,
              tableTitle: title,
              updateLoadedCrosstab: true,
              resetTable: false,
            });
          }
        }
      });
  };
}

export function validateTrendData({
  token,
  uid,
  accountId,
  productNumbers,
  weightType,
  divisor,
  baseList,
  baseHeaderList,
  colExpressionList,
  colHeaderList,
  rowExpressionList,
  rowHeaderList,
}) {
  const url = `${urls.ROOT_URL}/crosstab/${uid}/${accountId}/trend/validate`;
  const newColHeaderList = colHeaderList
    ? colHeaderList.map(item => item.replace(String.fromCharCode(10020), ''))
    : [];
  const newRowHeaderList = rowHeaderList
    ? rowHeaderList.map(item => item.replace(String.fromCharCode(10020), ''))
    : [];
  const newBaseHeaderList = baseHeaderList
    ? baseHeaderList.map(item => item.replace(String.fromCharCode(10020), ''))
    : [];

  return dispatch =>
    new Promise((resolve, reject) => {
      axios({
        url,
        method: 'post',
        headers: {
          Accept: 'application/json;charset=UTF-8',
        },
        withCredentials: true,
        responseType: 'json',
        data: {
          products: productNumbers,
          weightType,
          divisor,
          title: 'Title Not Needed',
          baseList,
          baseHeaderList: newBaseHeaderList,
          colExpressionList,
          colHeaderList: newColHeaderList,
          rowExpressionList,
          rowHeaderList: newRowHeaderList,
        },
      })
        .then(response => {
          resolve(response.data.data);
        })
        .catch(response => {
          console.warn(response);
          reject();
        });
    });
}

export const trendComplete = payload => ({
  type: types.VALID_TREND_ROW_COL_BASES,
  payload,
});

export const importNewSPC = (payload, importSPC) => ({
  type: types.LOAD_NEWSPC_SAVED_CROSSTAB,
  payload,
  importSPC,
});

export function validateNewSpcCRB({
  token,
  uid,
  accountId,
  productNo,
  weightType,
  divisor,
  baseList,
  baseHeaderList,
  baseOriginalHeaderList,
  colExpressionList,
  colHeaderList,
  colOriginalHeaderList,
  rowExpressionList,
  rowHeaderList,
  rowOriginalHeaderList,
  oldProductNo,
  isColLabelUpdated,
  isRowLabelUpdated,
  newSpcParams,
}) {
  const url = `${urls.ROOT_URL}/crosstab/${uid}/${accountId}/validate`;

  const newColHeaderList = colHeaderList
    ? colHeaderList.map(item => item.replace(String.fromCharCode(10020), ''))
    : [];
  const newRowHeaderList = rowHeaderList
    ? rowHeaderList.map(item => item.replace(String.fromCharCode(10020), ''))
    : [];
  const newBaseHeaderList = baseHeaderList
    ? baseHeaderList.map(item => item.replace(String.fromCharCode(10020), ''))
    : [];

  const newColOriginalHeaderList = colOriginalHeaderList
    ? colOriginalHeaderList.map(item =>
        item.replace(String.fromCharCode(10020), '')
      )
    : [];
  const newRowOriginalHeaderList = rowOriginalHeaderList
    ? rowOriginalHeaderList.map(item =>
        item.replace(String.fromCharCode(10020), '')
      )
    : [];
  const newBaseOriginalHeaderList = baseOriginalHeaderList
    ? baseOriginalHeaderList.map(item =>
        item.replace(String.fromCharCode(10020), '')
      )
    : [];

  return dispatch =>
    new Promise((resolve, reject) => {
      axios({
        url,
        method: 'post',
        headers: {
          Accept: 'application/json;charset=UTF-8',
        },
        withCredentials: true,
        responseType: 'json',
        data: {
          products: [`${productNo}`],
          weightType,
          divisor,
          title: 'Title Not Needed',
          baseList,
          oldProductNo,
          baseHeaderList: newBaseHeaderList,
          colExpressionList,
          colHeaderList: newColHeaderList,
          rowExpressionList,
          rowHeaderList: newRowHeaderList,
        },
      })
        .then(response => {
          dispatch({
            type: types.SHOW_NEWSPC_VALIDATE_RESPONSE,
            payload: response.data.data,
            baseOriginalHeaderList: newBaseOriginalHeaderList,
            colOriginalHeaderList: newColOriginalHeaderList,
            rowOriginalHeaderList: newRowOriginalHeaderList,
            oldProductNo,
            isColLabelUpdated,
            isRowLabelUpdated,
            newSpcParams,
          });
          resolve();
        })
        .catch(response => {
          console.warn(response);
          reject();
        });
    });
}

export function validateNewSpcCRBForMultipleProducts({
  token,
  uid,
  accountId,
  productNo,
  weightType,
  divisor,
  baseList,
  baseHeaderList,
  baseOriginalHeaderList,
  colExpressionList,
  colHeaderList,
  colOriginalHeaderList,
  rowExpressionList,
  rowHeaderList,
  rowOriginalHeaderList,
  isColLabelUpdated,
  isRowLabelUpdated,
  newSpcParams,
}) {
  const url = `${urls.ROOT_URL}/crosstab/${uid}/${accountId}/trend/validate`;

  const newColHeaderList = colHeaderList
    ? colHeaderList.map(item => item.replace(String.fromCharCode(10020), ''))
    : [];
  const newRowHeaderList = rowHeaderList
    ? rowHeaderList.map(item => item.replace(String.fromCharCode(10020), ''))
    : [];
  const newBaseHeaderList = baseHeaderList
    ? baseHeaderList.map(item => item.replace(String.fromCharCode(10020), ''))
    : [];

  const newColOriginalHeaderList = colOriginalHeaderList
    ? colOriginalHeaderList.map(item =>
        item.replace(String.fromCharCode(10020), '')
      )
    : [];
  const newRowOriginalHeaderList = rowOriginalHeaderList
    ? rowOriginalHeaderList.map(item =>
        item.replace(String.fromCharCode(10020), '')
      )
    : [];
  const newBaseOriginalHeaderList = baseOriginalHeaderList
    ? baseOriginalHeaderList.map(item =>
        item.replace(String.fromCharCode(10020), '')
      )
    : [];

  return dispatch =>
    axios({
      url,
      method: 'post',
      headers: {
        Accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
      data: {
        products: productNo,
        weightType,
        divisor,
        baseList,
        baseHeaderList: newBaseHeaderList,
        colExpressionList,
        colHeaderList: newColHeaderList,
        rowExpressionList,
        rowHeaderList: newRowHeaderList,
      },
    })
      .then(response =>
        dispatch({
          type: types.SHOW_NEWSPC_VALIDATE_RESPONSE,
          payload: response.data.data,
          baseOriginalHeaderList: newBaseOriginalHeaderList,
          colOriginalHeaderList: newColOriginalHeaderList,
          rowOriginalHeaderList: newRowOriginalHeaderList,
          trendMultipleProducts: true,
          isColLabelUpdated,
          isRowLabelUpdated,
          newSpcParams,
        })
      )
      .catch(response => console.warn(response));
}

export const getTrendStudiesData = (
  uid,
  accountId,
  productNo,
  weightType,
) => {
  const url = `${urls.ROOT_URL}/users/trend/release/studies/${uid}/${accountId}/${productNo}/${weightType}/100`;
  return axios({
    url,
    method: 'get',
    headers: {
      Accept: 'application/json;charset=UTF-8',
    },
    withCredentials: true,
    responseType: 'json',
    validateStatus: status => status >= 200 && status < 501,
  })
    .then(response => {
      if (response.status === 200) {
        return response.data.data;
      }
      return response;
    })
    .catch(response => console.warn(response));
}